import { MapPin, Check } from 'lucide-react';
import { Badge } from './ui/badge';
import { keyLocations } from '../mockData';

export const Locations = () => {
  return (
    <section id="locations" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Key Locations We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Premium properties in the most sought-after areas of Vrindavan and Mathura
          </p>
        </div>

        {/* Locations Grid */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {keyLocations.map((location, index) => (
              <div 
                key={index} 
                className="flex items-center space-x-3 p-4 rounded-lg hover:bg-orange-50 transition-colors duration-200 group"
              >
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-orange-600 transition-colors duration-200">
                  <MapPin className="w-5 h-5 text-orange-600 group-hover:text-white transition-colors duration-200" />
                </div>
                <span className="text-gray-900 font-medium">{location}</span>
              </div>
            ))}
          </div>

          {/* Special Focus Areas */}
          <div className="mt-10 pt-10 border-t border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">Special Focus Areas</h3>
            <div className="flex flex-wrap justify-center gap-3">
              <Badge className="bg-orange-600 text-white px-4 py-2 text-sm">
                <Check className="w-4 h-4 mr-2" />
                Near Temples & Ashrams
              </Badge>
              <Badge className="bg-orange-600 text-white px-4 py-2 text-sm">
                <Check className="w-4 h-4 mr-2" />
                Yamuna Ghat Proximity
              </Badge>
              <Badge className="bg-orange-600 text-white px-4 py-2 text-sm">
                <Check className="w-4 h-4 mr-2" />
                Parikrama Marg Access
              </Badge>
              <Badge className="bg-orange-600 text-white px-4 py-2 text-sm">
                <Check className="w-4 h-4 mr-2" />
                Premium Gated Colonies
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};